<template>
    <div id='captura' > 
        <br> 
        <div align="center">           
            <h1 ><b>Agregar inmueble</b></h1>
            <br>
            <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i> regresar</a>
        </div>
        <form v-on:submit.prevent= 'guardarProducto'>                

            <div class="column is-half is-offset-one-quarter " center>
                
                <br>

                <div class='field'>
                  <label class='label'>Tipo de inmueble</label>
                  <div class='control'>
                    <select class='select' type='text' v-model='inmuebles21.tipo47' maxlength='15' required >
                        <option value="Bodega">Bodega</option>
                        <option value="Casa">Casa</option>
                        <option value="Cuarto">Cuarto</option>
                        <option value="Departamento">Departamento</option>
                        <option value="Local-comercial">Local-comercial</option>
                        <option value="Oficina">Oficina</option>
                        <option value="Terreno">Terreno</option>
                    </select>
                  </div>
                </div>

                <div class='field'>
                  <label class='label'>Venta o Renta o Traspaso</label>
                  <div class='control'>
                    <select class='select' type='text' v-model='inmuebles21.ventaRenta' maxlength='8' required >
                        <option value="Renta">Renta</option>
                        <option value="Traspaso">Traspaso</option>
                        <option value="Venta">Venta</option>
                    </select>
                  </div>
                </div> 

                <div class='field'>
                  <label class='label'>Visibilidad del anuncio</label>
                  <div class='control'>
                    <select class='select' type='text' v-model='inmuebles21.status47' maxlength='1' required >
                        <option value="Visible">Visible a todo público</option>
                        <option value="No-visible">No visible</option>
                        <option value="Baja">Dar de baja</option>
                    </select>
                  </div>
                </div>                 

                <div class='field'>
                  <label class='label'>Titulo o encabezado (opcional)</label>
                  <div class='control'>
                      <input class='input' type='text' placeholder='Ej. Bonita casa de campo' v-model='inmuebles21.nombre47' maxlength="150">
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Descripcion detallada del inmueble</label>
                  <div class='control'>
                    <textarea class='textarea' type='text' v-model='inmuebles21.descripcion47' maxlength="400" required ></textarea>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Familia o linea de producto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' placeholder='Ej. Plaza del Parque' v-model='inmuebles21.familia47' maxlength='30' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Mail de contacto</label>
                  <div class='control'>
                    <input class='input' type='email'  v-model='inmuebles21.mailContacto47' maxlength='300' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Whatsapp de Contacto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='tel' v-model='inmuebles21.whatsappContacto' maxlength='15' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Celular de contacto</label>
                  <div class='control'>
                    <input class='input' type='tel'  v-model='inmuebles21.cel' maxlength='15' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Telefono de contacto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='tel' placeholder='cel2' v-model='inmuebles21.cel2' maxlength='15' >
                  </div>
                </div>                
                <div class='field'>
                  <label class='label'>Calle y Num.</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.direccion47' maxlength='200' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Colonia</label>
                  <div class='control'>
                    <input class='input' type='text'v-model='inmuebles21.colonia' maxlength='50' required >
                  </div>
                </div>
                <div class='field'>

                 
                  <label class='label'>Ciudad</label>
                  <div class='control'>
                   <select class='select' type='text' v-model='inmuebles21.mpio' required >
                                <option value=''>Todas</option>
                                <option value='Acapulco'>Acapulco</option>
                                <option value='Aguascalientes'>Aguascalientes</option>
                                <option value='Apodaca'>Apodaca</option>
                                <option value='Buenavista'>Buenavista</option>
                                <option value='Campeche'>Campeche</option>
                                <option value='Cancún'>Cancún</option>
                                <option value='Celaya'>Celaya</option>
                                <option value='Chalco'>Chalco</option>
                                <option value='Chetumal'>Chetumal</option>
                                <option value='Chicoloapan'>Chicoloapan</option>
                                <option value='Chihuahua'>Chihuahua</option>
                                <option value='Chilpancingo'>Chilpancingo</option>
                                <option value='Chimalhuacán'>Chimalhuacán</option>
                                <option value='Ciudad Acuña'>Ciudad Acuña</option>
                                <option value='Ciudad de México'>Ciudad de México</option>
                                <option value='Ciudad del Carmen'>Ciudad del Carmen</option>
                                <option value='Ciudad López Mateos'>Ciudad López Mateos</option>
                                <option value='Ciudad Madero'>Ciudad Madero</option>
                                <option value='Ciudad Obregón'>Ciudad Obregón</option>
                                <option value='Ciudad Valles'>Ciudad Valles</option>
                                <option value='Ciudad Victoria'>Ciudad Victoria</option>
                                <option value='Coatzacoalcos'>Coatzacoalcos</option>
                                <option value='Colima'>Colima</option>
                                <option value='Córdoba'>Córdoba</option>
                                <option value='Corregidora'>Corregidora</option>
                                <option value='Cuauhtémoc'>Cuauhtémoc</option>
                                <option value='Cuautitlán'>Cuautitlán</option>
                                <option value='Cuautitlán Izcalli'>Cuautitlán Izcalli</option>
                                <option value='Cuautla'>Cuautla</option>
                                <option value='Cuernavaca'>Cuernavaca</option>
                                <option value='Culiacán'>Culiacán</option>
                                <option value='Delicias'>Delicias</option>
                                <option value='Durango'>Durango</option>
                                <option value='Ecatepec'>Ecatepec</option>
                                <option value='El Marquez'>El Marques</option>
                                <option value='Ensenada'>Ensenada</option>
                                <option value='Fresnillo'>Fresnillo</option>
                                <option value='General Escobedo'>General Escobedo</option>
                                <option value='Gómez Palacio'>Gómez Palacio</option>
                                <option value='Guadalajara'>Guadalajara</option>
                                <option value='Guadalupe'>Guadalupe</option>
                                <option value='Guadalupe'>Guadalupe</option>
                                <option value='Guaymas'>Guaymas</option>
                                <option value='Hermosillo'>Hermosillo</option>
                                <option value='Hidalgo del Parral'>Hidalgo del Parral</option>
                                <option value='Iguala'>Iguala</option>
                                <option value='Irapuato'>Irapuato</option>
                                <option value='Ixtapaluca'>Ixtapaluca</option>
                                <option value='Jiutepec'>Jiutepec</option>
                                <option value='Juárez'>Juárez</option>
                                <option value='Juárez'>Juárez</option>
                                <option value='La Paz'>La Paz</option>
                                <option value='Lagos de Moreno'>Lagos de Moreno</option>
                                <option value='León'>León</option>
                                <option value='Los Cabos'>Los Cabos</option>
                                <option value='Los Mochis'>Los Mochis</option>
                                <option value='Manzanillo'>Manzanillo</option>
                                <option value='Matamoros'>Matamoros</option>
                                <option value='Mazatlán'>Mazatlán</option>
                                <option value='Mérida'>Mérida</option>
                                <option value='Mexicali'>Mexicali</option>
                                <option value='Minatitlán'>Minatitlán</option>
                                <option value='Miramar'>Miramar</option>
                                <option value='Monclova'>Monclova</option>
                                <option value='Monterrey'>Monterrey</option>
                                <option value='Morelia'>Morelia</option>
                                <option value='Naucalpan'>Naucalpan</option>
                                <option value='Naucalpan de Juárez'>Naucalpan de Juárez</option>
                                <option value='Navojoa'>Navojoa</option>
                                <option value='Nezahualcóyotl'>Nezahualcóyotl</option>
                                <option value='Nogales'>Nogales</option>
                                <option value='Nuevo Laredo'>Nuevo Laredo</option>
                                <option value='Oaxaca de Juárez'>Oaxaca de Juárez</option>
                                <option value='Ojo de Agua'>Ojo de Agua</option>
                                <option value='Orizaba'>Orizaba</option>
                                <option value='Pachuca'>Pachuca</option>
                                <option value='Piedras Negras'>Piedras Negras</option>
                                <option value='Playa del Carmen'>Playa del Carmen</option>
                                <option value='Poza Rica de Hidalgo'>Poza Rica de Hidalgo</option>
                                <option value='Puebla'>Puebla</option>
                                <option value='Puerto Vallarta'>Puerto Vallarta</option>
                                <option value='Querétaro'>Querétaro</option>
                                <option value='Reynosa'>Reynosa</option>
                                <option value='Salamanca'>Salamanca</option>
                                <option value='Saltillo'>Saltillo</option>
                                <option value='San Cristóbal de las Casas'>San Cristóbal de las Casas</option>
                                <option value='San Francisco Coacalco'>San Francisco Coacalco</option>
                                <option value='San Juan Bautista Tuxtepec'>San Juan Bautista Tuxtepec</option>
                                <option value='San Juan del Río'>San Juan del Río</option>
                                <option value='San Juan del Los Lagos'>San Juan del Los Lagos</option>
                                <option value='San Luis Potosí'>San Luis Potosí</option>
                                <option value='San Luis Río Colorado'>San Luis Río Colorado</option>
                                <option value='San Miguel de Allende'>San Miguel de Allende</option>
                                <option value='San Nicolás de los Garza'>San Nicolás de los Garza</option>
                                <option value='San Pablo de las Salinas'>San Pablo de las Salinas</option>
                                <option value='San Pedro Garza García'>San Pedro Garza García</option>
                                <option value='Santa Catarina'>Santa Catarina</option>
                                <option value='Soledad de Graciano Sánchez'>Soledad de Graciano Sánchez</option>
                                <option value='Tampico'>Tampico</option>
                                <option value='Tapachula'>Tapachula</option>
                                <option value='Taxco'>Taxco</option>
                                <option value='Tehuacán'>Tehuacán</option>
                                <option value='Tepexpan'>Tepexpan</option>
                                <option value='Tepic'>Tepic</option>
                                <option value='Texcoco de Mora'>Texcoco de Mora</option>
                                <option value='Tijuana'>Tijuana</option>
                                <option value='Tlalnepantla'>Tlalnepantla</option>
                                <option value='Tlaquepaque'>Tlaquepaque</option>
                                <option value='Toluca'>Toluca</option>
                                <option value='Tonalá'>Tonalá</option>
                                <option value='Torreón'>Torreón</option>
                                <option value='Tulancingo de Bravo'>Tulancingo de Bravo</option>
                                <option value='Tuxtla'>Tuxtla</option>
                                <option value='Uruapan'>Uruapan</option>
                                <option value='Veracruz'>Veracruz</option>
                                <option value='Villa de Álvarez'>Villa de Álvarez</option>
                                <option value='Villa Nicolás Romero'>Villa Nicolás Romero</option>
                                <option value='Villahermosa'>Villahermosa</option>
                                <option value='Xalapa Enriquez'>Xalapa Enriquez</option>
                                <option value='Xico'>Xico</option>
                                <option value='Zacatecas'>Zacatecas</option>
                                <option value='Zamora'>Zamora</option>
                                <option value='Zapopan'>Zapopan</option>
                   </select>

                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Delegación (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.deleg' maxlength='50' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Estado</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.edo' maxlength='50' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Codigo Postal (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' placeholder='codigoPostal' v-model='inmuebles21.codigoPostal' maxlength='5' >
                  </div>
                </div>                
                <div class='field'>
                  <label class='label'>Pais</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.pais' maxlength='50' required  value="México">
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>M2 de terreno (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.m2T' maxlength='7' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>M2 de construccion (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text'  v-model='inmuebles21.m2C' maxlength='7' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Importe $</label>
                  <div class='control'>
                    <input class='input' type='number'  v-model='inmuebles21.importe1' maxlength='15' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Moneda</label>
                  <div class='control'>
                    <select class="select is-small" v-model='inmuebles21.moneda1' required >
                      <option>MX</option>
                      <option>USD</option>
                    </select>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Requisitos (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' placeholder='Ej. Un mes de deposito, aval en la ciudad, poliza juridica ...' v-model='inmuebles21.requisitos' maxlength='200' >
                  </div>
                </div>                
                <div class='field'>
                  <label class='label'>Web del inmueble o inmobiliaria (opcional)</label>
                  <div class='control'>
                    <input class='input' type='web' v-model='inmuebles21.web47' maxlength='200' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Facebook del inmueble o inmobiliaria (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.facebook47' maxlength='200' >
                  </div>
                </div>

                <div class='field'>
                  <label class='label'>Ubicacion en Maps o Google Earth (ingresa a maps y pégala aquí) (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.ubicacion' placeholder="Ej. https://maps.app.goo.gl/aecdZ7BDmhKgXTC21" maxlength='200' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Codigo interno (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.codigoInterno' maxlength='30' >
                  </div>
                </div>
                <br>

                <div class='field'>
                  <div class="container">
                    <div class="large-12 medium-12 small-12 cell">
                        <div class="notification">
                            <i class="fas fa-camera"></i>
                            Recuerde que buenas fotos son muy importantes para rentar o vender su inmueble<br>
                            <b>rentas-ventas.com</b> le dice como <a href="https://www.caballerofotografia.com/home-staging-fotografia-interiores/" target='_blank'>aqui</a>
                        </div>
                        <label for="archi"><b>Subir imagen 1 del inmueble (opcional)</b></label>
                            <input class = "input" type="file" name="archi" id="miArchivoRentasVentas" ref="fot1" v-on:change="archivoAsubir('fot1')" >
                        </label>
                    </div>                
                  </div> 
                </div>
                    
                <div class='field'>
                    <div class="container">
                        <div class="large-12 medium-12 small-12 cell">
                            <label for="archi2"><b>Subir imagen 2 del inmueble (opcional)</b></label>
                                <input class = "input" type="file" name="archi2" id="miArchivoRentasVentas2" ref="fot2" v-on:change="archivoAsubir('fot2')" >
                            </label>
                        </div>                
                    </div> 
                </div>

                <div class='field'>
                    <div class="container">
                        <div class="large-12 medium-12 small-12 cell">
                            <label for="archi2"><b>Subir imagen logo de la inmobiliaria (opcional)</b></label>
                                <input class = "input" type="file" name="logo" id="miArchivoRentasVentas3" ref="logo" v-on:change="archivoAsubir('logo')" >
                            </label>
                        </div>                
                    </div>
                </div>

                <div class='field'>
                    <div class='field'>
                      <label class='label'>Liga de video de Youtube del inmueble (opcional)</label>
                      <div class='control'>
                         <input class='input is-primary' type='text' v-model='inmuebles21.videoYou' placeholder="Ponga aqui la direccion al video de youtube">
                      </div>
                      <br>
                      <button type="button" v-on:click="verId(inmuebles21.videoYou)" >
                            Ver el video
                      </button>
                      <div>
                        <iframe width="320" height="180" v-bind:src="'//www.youtube.com/embed/' + cualVideo +'?rel=0&showinfo=0&controls=1&autoplay=1&start=120' " frameborder="0" allowfullscreen>                                  
                        </iframe>
                      </div>
                    </div>
                </div>
                    

                <br><br>
            </div>
            <div align="center">
                <input class="button is-primary" type="submit" name="agrega" value="Agregar" >
            </div>
            <br><br>
        
        </form>
    </div>
</template>

<script>
    import axios from 'axios';
    export default{
            name:'agrega-inmueble',
            props: ['vector', 'elusuario'],  
            mounted(){
                this.status = 'P';
                this.mailAutorizado = this.$route.params.autorizado;
                if (this.mailAutorizado == null || this.mailAutorizado == '') this.$router.push("/");
            },
            data(){
                return {
                    inmuebles21:{
                        micrositio:"",
                        codigoInterno:"",
                        nombre47:"",
                        familia47:"",
                        contactoNom47:"",
                        direccion47:"",
                        mailContacto47:"",
                        whatsappContacto:"",
                        descripcion47:"",
                        cel:"",
                        cel2:"",
                        web47:"",
                        facebook47:"",
                        qr47:"",
                        tipo47:"",
                        foto1:"",
                        foto2:"",
                        videoYou:"",
                        logo47:"",
                        colonia:"",
                        mpio:"",
                        edo:"",
                        pais:"México",
                        deleg:"",
                        ventaRenta:"",
                        m2C:"",
                        m2T:"",
                        importe1:"",
                        moneda1:"MX",
                        um1:"",
                        importe2:"",
                        codigoPostal:"",
                        um2:"",
                        ubicacion:"",
                        status47:""
                        
                    },
                    siTiempo: false,
                    siMaterial: false,
                    siServicios: false,
                    siDinero: false,
                    siPromo: false,
                    mailAutorizado:'',
                    elArchivo:'',
                    cualVideo:''                    
                };
            },
            methods:{
                guardarProducto(){

                    var inmuebles21A = this.inmuebles21;
                    var router = this.$router;

                    // define el numero irrepetible del inmueble para ir al micrositio
                    var d = new Date();
                    var numeroUnico = d.getTime();
                    var micrositio1 = numeroUnico.toString();

                    if(inmuebles21A.foto1.name == "undefined"){
                        inmuebles21A.foto1.name = ""; 
                    } 
                    if(inmuebles21A.foto2.name == "undefined") {
                        inmuebles21A.foto2.name = "";
                    }
                    if(inmuebles21A.logo47.name == "undefined"){
                        inmuebles21A.logo47.name = "";  
                    } 

                    axios.post('https://www.rentas-ventas.com/agregaProducto.php?usuario47='+this.mailAutorizado
                        + '&micrositio='+micrositio1
                        + '&codigoInterno='+this.inmuebles21.codigoInterno
                        + '&nombre47='+this.inmuebles21.nombre47
                        + '&familia47='+this.inmuebles21.familia47
                        + '&contactoNom47='+this.inmuebles21.contactoNom47
                        + '&direccion47='+this.inmuebles21.direccion47
                        + '&mailContacto47='+this.inmuebles21.mailContacto47
                        + '&whatsappContacto='+this.inmuebles21.whatsappContacto
                        + '&descripcion47='+this.inmuebles21.descripcion47
                        + '&cel='+this.inmuebles21.cel
                        + '&cel2='+this.inmuebles21.cel2
                        + '&web47='+this.inmuebles21.web47
                        + '&facebook47='+this.inmuebles21.facebook47
                        + '&qr47='+this.inmuebles21.qr47
                        + '&tipo47='+this.inmuebles21.tipo47
                        + '&foto1='+this.inmuebles21.foto1.name
                        + '&foto2='+this.inmuebles21.foto2.name
                        + '&logo47='+this.inmuebles21.logo47.name
                        + '&videoYou='+this.inmuebles21.videoYou
                        + '&colonia='+this.inmuebles21.colonia
                        + '&mpio='+this.inmuebles21.mpio
                        + '&edo='+this.inmuebles21.edo
                        + '&pais='+this.inmuebles21.pais
                        + '&deleg='+this.inmuebles21.deleg
                        + '&ventaRenta='+this.inmuebles21.ventaRenta
                        + '&m2C='+this.inmuebles21.m2C
                        + '&m2T='+this.inmuebles21.m2T
                        + '&importe1='+this.inmuebles21.importe1
                        + '&moneda1='+this.inmuebles21.moneda1
                        + '&um1='+this.inmuebles21.um1
                        + '&importe2='+this.inmuebles21.importe2
                        + '&codigoPostal='+this.inmuebles21.codigoPostal
                        + '&um2='+this.inmuebles21.um2
                        + '&ubica47='+this.inmuebles21.ubicacion
                        + '&status47='+this.inmuebles21.status47

                        )
                          .then((respue) => {
                                if(this.inmuebles21.foto1.name != '' || this.inmuebles21.foto2.name != '' || this.logo47.name != '')
                                { 
                                    this.subeFotos();
                                }
                                alert("Inmueble subido");
                                router.go(-1);
                          })
                          .catch((error) =>{
                               alert('NO se agregó el producto. Error: ' + error);
                          });
                          
                },
                verId(liga){
                    var indice = liga.indexOf("?v=");
                    this.cualVideo = liga.substring(indice+3);
                    // alert(idVideo);
                    // http://www.youtube.com/watch?v=vKZRsKN7b8c
                },
                archivoAsubir(deQuien){
                    // obtiene el archivo seleccionado en el input llamado cualArchivoEs
                    // foto1, foto2 y logo47 son objetos

                    if(deQuien == 'fot1' ){
                        this.inmuebles21.foto1 = this.$refs.fot1.files[0];
                    }
                    if(deQuien == 'fot2' ){
                        this.inmuebles21.foto2 = this.$refs.fot2.files[0];
                    }
                    if(deQuien == 'logo' ){
                        this.inmuebles21.logo47 = this.$refs.logo.files[0];
                    }                    

                },
                subeFotos(){
                        // Se debe llamar igual el id del input y asi tambien 
                        // al recibirlo en subeArchivos.php el primero en el arreglo
                        // de $_FILES se debe llamar tambien igual y en el
                        // move_uploaded_file del .php, en este 
                        // caso miArchivoRentasVentas en los 4 lugares                        
                        // toma el nombre del archivo
                        let formData = new FormData();

                        formData.append('miArchivoRentasVentas', this.inmuebles21.logo47);

                        //Make the request to the POST /single-file URL                     
                        axios.post( 'https://www.rentas-ventas.com/subeArchivo.php',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'                   
                                }
                            }
                            ).then(function(){
                                alert('LOGO SUBIENDO');
                            })
                            .catch(function(){
                                alert('No subió el logo al servidor');
                            });


                        let formData1 = new FormData();

                        formData1.append('miArchivoRentasVentas', this.inmuebles21.foto1);
                        //Make the request to the POST /single-file URL                     
                        axios.post( 'https://www.rentas-ventas.com/subeArchivo.php',
                            formData1,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'                   
                                }
                            }
                            ).then(function(){
                                alert('FOTO 1 SUBIENDO');
                            })
                            .catch(function(){
                                alert('FALLO SUBIR FOTO 1 !!');
                            });  


                        let formData2 = new FormData();
                        formData2.append('miArchivoRentasVentas', this.inmuebles21.foto2);
                        axios.post( 'https://www.rentas-ventas.com/subeArchivo.php',
                            formData2,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'                   
                                }
                            }
                            ).then(function(){
                                alert('FOTO 2 SUBIENDO!!');
                            })
                            .catch(function(){
                                alert('FALLO SUBIR FOTO 2 !!');
                            });  

                }         


            }
    }
</script>


// WEBPACK FOOTER //
// src/Productos-alta.vue